import './blogs.scss'
import {NavLink} from "react-router-dom";
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import {BlogArrIcon, BusinessBlogIcon, EventsBlogIcon, TravelBlogIcon, VideoBlogIcon} from "../../assets/images";


 function Blogs(props){
    const {staticTexts} = props

    return <div className="blogs_container">
        <NavLink to="/event" activeClassName="active" className="blog_link events">
            <div className="blog_icon">
                <EventsBlogIcon/>
            </div>
            <span className="nav-item">{staticTexts?.header_item_events}</span>
            <div className="hover_arr">
                <BlogArrIcon/>
            </div>
        </NavLink>

        <NavLink to="/video" activeClassName="active" className="blog_link videos">
            <div className="blog_icon">
                <VideoBlogIcon/>
            </div>
            <span className="nav-item">{staticTexts?.header_item_videos}</span>
            <div className="hover_arr">
                <BlogArrIcon/>
            </div>
        </NavLink>

        <NavLink to="/travel" activeClassName="active" className="blog_link travel">
            <div className="blog_icon">
                <TravelBlogIcon/>
            </div>
            <span className="nav-item">{staticTexts?.header_item_traveling}</span>
            <div className="hover_arr">
                <BlogArrIcon/>
            </div>
        </NavLink>

        <NavLink to="/project" activeClassName="active" className="blog_link projects">
            <div className="blog_icon">
                <BusinessBlogIcon/>
            </div>
            <span className="nav-item">{staticTexts?.header_item_projects}</span>
            <div className="hover_arr">
                <BlogArrIcon/>
            </div>
        </NavLink>
    </div>

 }
const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(Blogs);